// 健康服务相关接口
import request from './request'

/**
 * 获取健康服务数据
 * @param {Object} params - 请求参数
 * @param {string} params.userId - 用户 ID
 * @returns {Promise}
 */
export function getHealthServices(params) {
  return request({
    url: '/api/health/services',
    method: 'get',
    params
  })
}

